import type { NextPage } from 'next'
import { Contact } from '@/client/modules/Contact'
import { ContactProps } from '@/client/modules/Contact/types'
import { getCMSContent } from '@/client/utils'

const ContactPage: NextPage<ContactProps> = (data) => <Contact {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'CONTACT')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default ContactPage
